import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { decryptfromHEX } from "../../routes/encodedecode.js";

function SubmissionData({ postId, postUrl }) {
  const [datePosted, setDatePosted] = useState("");
  const [totalSubmissions, setTotalSubmissions] = useState("");
  const [firstSubmissionDate, setFirstSubmissionDate] = useState("");
  const [recentSubmissionDate, setRecentSubmissionDate] = useState("");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const encrypted = queryParams.get("p");
  console.log("query params: ", encrypted);
  let orgID = "";
  if (encrypted) {
    try {
      const decrypted = decryptfromHEX(encrypted);
      const parsed = JSON.parse(decrypted);
      orgID = parsed.orgID;
      console.log("Decrypted orgID here:", orgID);
    } catch (err) {
      console.error("Failed to decrypt orgID from URL:", err);
    }
  }

  console.log("post url: ", postUrl);

  function formatDate(utcString) {
    const date = new Date(datePosted);

    const formatted = `${String(date.getMonth() + 1).padStart(2, "0")}/${String(
      date.getDate(),
    ).padStart(2, "0")}`;

    return formatted;
  }

  function timeAgoShort(utcString) {
    if (!utcString) return "";

    const date = new Date(utcString);
    const sec = Math.floor((Date.now() - date.getTime()) / 1000);
    if (sec < 0) return "just now"; // future-ish times

    if (sec < 60) return `${sec}s ago`;
    const mins = Math.floor(sec / 60);
    if (mins < 60) return `${mins}m ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    if (days < 7) return `${days}d ago`;
    const weeks = Math.floor(days / 7);
    if (weeks < 4) return `${weeks}wk${weeks > 1 ? "s" : ""} ago`;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months}mo ago`;
    const years = Math.floor(days / 365);
    return `${years}y ago`;
  }

  function convertUTCToMonthDay(firstDate, lastDate) {
    if (!firstDate && !lastDate) return "No Submission Data found";

    console.log("the dates: ", firstDate, lastDate);

    const ts1 = firstDate ? new Date(firstDate).getTime() : null;
    const ts2 = lastDate ? new Date(lastDate).getTime() : null;

    let mostRecent = null;
    let leastRecent = null;

    if (ts1 && ts2) {
      if (ts1 > ts2) {
        mostRecent = firstDate;
        leastRecent = lastDate;
      } else {
        mostRecent = lastDate;
        leastRecent = firstDate;
      }
    } else {
      // only one date present
      mostRecent = firstDate || lastDate || null;
    }

    const recentText = mostRecent ? timeAgoShort(mostRecent) : "";
    const earliestText = leastRecent ? timeAgoShort(leastRecent) : "";

    return earliestText ? `${recentText} - ${earliestText}` : recentText;
  }

  useEffect(() => {
    const fetchSubmissionData = async () => {
      try {
        console.log("calling submssion data api");
        const response = await fetch(
          `https://genz-staging.feeltiptop.com/api/social_glass/getSubmissionData?postId=${postId}&orgId=${orgID}`,
        );
        const data = await response.json();
        console.log("data in fetch submission: ", data);

        //        payload = {

        //     'totalSubmissions': total_submissions,
        //     'firstSubmissionDate': first_submitted,
        //     'recentSubmissionDate': recently_submitted
        // }

        if (data) {
          if (
            data.firstSubmissionDate !== "-1" &&
            data.firstSubmissionDate !== -1
          ) {
            setFirstSubmissionDate(data.firstSubmissionDate);
          }
          if (
            data.recentSubmissionDate !== "-1" &&
            data.recentSubmissionDate !== -1
          ) {
            setRecentSubmissionDate(data.recentSubmissionDate);
          }

          if (data.datePosted !== "" && data.datePosted !== null) {
            setDatePosted(data.datePosted);
          }

          setTotalSubmissions(data.totalSubmissions);
        } else {
          console.warn("No data being returned", data);
        }

        if (data?.total_count !== undefined) {
          setTotalSubmissions(data.total_count);
        }
      } catch (error) {
        console.error("Error fetching submission data:", error);
      }
    };
    if (orgID !== "") {
      fetchSubmissionData();
    }
  }, [postId]);

  return (
    <div className="h-auto w-auto p-4 font-sans">
      {/* Date of the post */}
      <p className="text-sm text-gray-600">
        Posted:{datePosted && formatDate(datePosted)}
      </p>

      {/* Gray container box */}
      <div className="mt-1 rounded-lg bg-gray-100 p-2">
        <p className="text-xs font-medium text-gray-800">
          {totalSubmissions} submissions
          <p className="block">
            {convertUTCToMonthDay(firstSubmissionDate, recentSubmissionDate)}
          </p>
        </p>

        {/* Link to the original post */}

        {/* You can add the time frame element here when ready */}
      </div>
      <a
        href={postUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-2 inline-flex items-center gap-x-1.5 rounded text-xs font-semibold text-red-600 transition-colors hover:text-red-700 hover:underline focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
      >
        <span>View Original Post</span>

        {/* External link icon to indicate leaving the site */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
          <polyline points="15 3 21 3 21 9"></polyline>
          <line x1="10" y1="14" x2="21" y2="3"></line>
        </svg>
      </a>
    </div>
  );
}

export default SubmissionData;
